import React from 'react'
import { Form, Button, Input } from 'antd'
import { scrapingTagFormInitalValues } from './initial-values'
import { scrapingTagEditorFormRules } from './rules'
import PropTypes from 'prop-types'

const tailLayout = {
  wrapperCol: { offset: 20, span: 2 },
}

const ScrapingTagEditorForm = ({ tag, onSubmit, isSubmitting }) => {
  const initialValues = scrapingTagFormInitalValues(tag)

  return (
    <Form
      initialValues={initialValues}
      onFinish={onSubmit}
      preserve={false}
      scrollToFirstError
    >
      <Form.Item name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Name"
        name="name"
        rules={scrapingTagEditorFormRules.name}
      >
        <Input />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit" loading={isSubmitting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  )
}

ScrapingTagEditorForm.propTypes = {
  tag: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
}

ScrapingTagEditorForm.defaultProps = {
  tag: {},
}

export default ScrapingTagEditorForm
